const ULX_LYP_HOME_PAGE = 'UlxLypHomePage';
const BED_BATH_PAGE = 'BedAndBath';
const LOCATION_PAGE = 'Location';
const MANUAL_LOCATION_PAGE = 'ManualLocation';
const LEAD_PAGE = 'LeadForm';
const MISSING_DETAILS_PAGE = 'MissingDetails';
const ESTIMATE_PAGE = 'EstimateResults';
const UNIFIED_ONBOARDING = 'UnifiedOnboarding';
const VALIDATE_AUTH_TICKET = 'ValidateAuthTicket';
const UPDATE_ACCOUNT_PAGE = 'UpdateAccount';
const UPGRADE_AUTH_REDIRECT = 'UpgradeAuthRedirect';
const LOGIN_INTERSTITIAL = 'LoginInterstitial';
const CL_PROPERTY_INFO = 'ClPropertyInfo';
const CLASSIFICATION = 'ClassificationStep';
const LANGUAGE_SELECTION = 'LanguageSelectionStep';
const CL_EMAIL_VERIFICATION = 'ClEmailVerification';
const CL_IS_EMAIL_VERIFIED = 'ClIsEmailVerified';
const CL_ELIGIBILITY_CHECK = 'ClEligibilityCheck';
const EXTERNAL_FLOW_PAGE = 'ExternalFlowPage';
const CONFIRM_LOCATION = 'ConfirmLocation';
const CL_AAPV2 = 'ClAddPropertyV2';
const MULTIPROPERTY_ONBOARDING = 'MultiPropertyOnboarding';
const CL_CONTRACT_ONBOARDING = 'ClContractOnboarding';
const DOM_UTILS_CTX = 'DomUtilsCtx';
const JOIN_HANDLER = 'JoinHandler';
const CL_CONTRACT_ONBOARDING_AAP = 'ClContractOnboardingAddProperty';
const VRBO_HANDLER = 'VrboHandler';

// AAP pages
const AAPLOCATION_PAGE = 'AAPLocation';
const AAPMANUAL_LOCATION_PAGE = 'AAPManualLocation';
const AAPCONFIRM_LOCATION = 'AAPConfirmLocation';
const AAPCL_PROPERTY_INFO = 'AAPClPropertyInfo';


export {
    ULX_LYP_HOME_PAGE,
    BED_BATH_PAGE,
    LOCATION_PAGE,
    MANUAL_LOCATION_PAGE,
    LEAD_PAGE,
    MISSING_DETAILS_PAGE,
    ESTIMATE_PAGE,
    VALIDATE_AUTH_TICKET,
    UPDATE_ACCOUNT_PAGE,
    UPGRADE_AUTH_REDIRECT,
    LOGIN_INTERSTITIAL,
    CL_PROPERTY_INFO,
    CLASSIFICATION,
    LANGUAGE_SELECTION,
    UNIFIED_ONBOARDING,
    CL_EMAIL_VERIFICATION,
    CL_ELIGIBILITY_CHECK,
    EXTERNAL_FLOW_PAGE,
    CONFIRM_LOCATION,
    CL_IS_EMAIL_VERIFIED,
    CL_AAPV2,
    MULTIPROPERTY_ONBOARDING,
    CL_CONTRACT_ONBOARDING,
    DOM_UTILS_CTX,
    JOIN_HANDLER,
    CL_CONTRACT_ONBOARDING_AAP,
    AAPLOCATION_PAGE,
    AAPMANUAL_LOCATION_PAGE,
    AAPCONFIRM_LOCATION,
    AAPCL_PROPERTY_INFO,
    VRBO_HANDLER
};
